import { Alert } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface RouteErrorProps {
  error?: unknown;
}

export function RouteError({ error }: RouteErrorProps) {
  const { t } = useTranslation();
  const message =
    error instanceof Error ? error.message : t("common.unexpectedError");
  return (
    <Alert role="alert" color="red" title={t("common.error")} m="xl">
      {message}
    </Alert>
  );
}
